// extracted by mini-css-extract-plugin
export default {"SvgIcon":"Icons_SvgIcon__u3ANN","rotation":"Icons_rotation__CoSyy"};